import { ReactNode } from 'react';

import { SignatureDocumentDetailsModal } from '../components/signatures-modal/signature-document-details-modal';
import { SignatureSendReminderModal } from '../components/signatures-modal/signature-send-reminder-modal';
import { SignatureSigningModal } from '../components/signatures-modal/signature-signing-modal';
import { SignaturePreviewModal } from '../components/signatures-modal/signature-view-document-modal';
import { SignaturesModal } from '../components/signatures-modal/signatures-modal';
import { SignaturePopupType } from '../enums/signature-popup-type.const';

export type SignaturePopupTypeComponentMap = Record<SignaturePopupType, ReactNode>;

export const signaturePopupTypeComponentMap: SignaturePopupTypeComponentMap = {
  [SignaturePopupType.SEND_REMINDER]: <SignatureSendReminderModal />,
  [SignaturePopupType.SIGN_DOCUMENT]: <SignatureSigningModal />,
  [SignaturePopupType.VIEW_DOCUMENT]: <SignaturePreviewModal />,
  [SignaturePopupType.VIEW_DOCUMENT_DETAILS]: <SignatureDocumentDetailsModal />,
  [SignaturePopupType.VIEW_SIGNATURES]: <SignaturesModal />,
};
